/**
 * Configuration utilities for Insiders DAW
 * Provides access to environment variables and API endpoints
 */

/**
 * Get the backend API base URL
 */
export const getApiBaseUrl = (): string => {
  return import.meta.env.VITE_API_BASE_URL || 'http://localhost:8787';
};

/**
 * Get the CDN base URL for static assets
 */
export const getCdnBaseUrl = (): string => {
  return import.meta.env.VITE_CDN_BASE_URL || 'http://localhost:8787';
};

/**
 * Get the public platform URL
 */
export const getPublicUrl = (): string => {
  return import.meta.env.VITE_PUBLIC_URL || 'http://localhost:5173';
};

/**
 * Build a full API URL from a path
 * @param path - API path (e.g., '/api/projects')
 */
export const apiUrl = (path: string): string => {
  const base = getApiBaseUrl();
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${cleanPath}`;
};

/**
 * Build a full CDN URL from a path
 * @param path - Asset path (e.g., '/samples/kick.wav')
 */
export const cdnUrl = (path: string): string => {
  const base = getCdnBaseUrl();
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${cleanPath}`;
};
